import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Popup from '../../../Popup/Popup';
import './TopUpPopup.css';
import { TranslationContext } from '../../../../assets/contexts/translationContext';
import { PopupContext } from '../../../../assets/contexts/popupContex';
import {
  TAP_BTN_SCALE,
  TOP_UP_POPUP_TYPE,
} from '../../../../assets/utils/constants';
import gems from '../../../../assets/icons/gems-icon.png';
import { UserContext } from '../../../../assets/contexts/userContext';
import { GemsLogo } from '../../../../assets/icons/icons';

function TopUpPopup({ price }) {
  const {
    reader: {
      paywall: {
        topUpPopup: { title, confirm, decline },
      },
    },
  } = useContext(TranslationContext);
  const { handlePopupClose } = useContext(PopupContext);
  const { user } = useContext(UserContext);
  const balance = user?.balance;
  const diff = Number(price) - Number(balance);

  return (
    <Popup
      popupName={TOP_UP_POPUP_TYPE}
      color={'var(--paywall-bg-color)'}
      fitContent
    >
      <div className="top-up-popup">
        <div className="top-up-popup__heading">
          <img src={gems} alt="" className="top-up-popup__logo" />
          <p className="top-up-popup__title">
            {title.start}
            <span className="top-up-popup__title_weight_bold">
              {title.price(diff)}
            </span>
            {title.end}
          </p>
        </div>

        <div className="top-up-popup__btns">
          <motion.div
            className="top-up-popup__link-btn"
            whileHover={{ scale: 1.01 }}
            whileTap={{ scale: TAP_BTN_SCALE }}
          >
            <Link
              className="top-up-popup__link"
              onClick={() => handlePopupClose(TOP_UP_POPUP_TYPE)}
            >
              <GemsLogo
                mainClassName="top-up-popup__link-logo"
                strokeClassName="top-up-popup__link-logo-stroke"
              />
              <p className="top-up-popup__btn-text">
                {confirm.start}
                <span className="top-up-popup__btn-text_weight_bold">
                  {confirm.price(diff)}
                </span>
                {confirm.end}
              </p>
            </Link>
          </motion.div>

          <motion.button
            className="top-up-popup__btn"
            type="button"
            onClick={() => handlePopupClose(TOP_UP_POPUP_TYPE)}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: TAP_BTN_SCALE }}
          >
            <p className="top-up-popup__btn-text top-up-popup__btn-text_type_decline">
              {decline}
            </p>
          </motion.button>
        </div>
      </div>
    </Popup>
  );
}

export default TopUpPopup;
